import { FILE_TYPES } from 'utils/constants';

export const generateContentTypeLabel = (contentPiece) => {
    let label = contentPiece.type;
    if(contentPiece.type === 'file') {
        label = FILE_TYPES[contentPiece.file.contentType];
    } else if(contentPiece.type === 'web') {
        if(contentPiece.marketingType === 'elearning') {
            label = 'E-Learning';
        } else {
            label = 'Web Link';
        }
    } else if(contentPiece.type === 'html') {
        label = 'Document';
    }

    return label;
};



// WEBPACK FOOTER //
// ./src/containers/ContentPage/utils.js